import script from "./PrefabWallDetailTab.vue?vue&type=script&setup=true&lang=js"
export * from "./PrefabWallDetailTab.vue?vue&type=script&setup=true&lang=js"

import "./PrefabWallDetailTab.vue?vue&type=style&index=0&id=4687d621&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4687d621"]])

export default __exports__